export default __webpack_public_path__ + "static/media/icon-legend.640108c5.svg";